
export default function RelativeDifferenceGameAnswer({sign, answer}) {
    // Used in RelativeDifferenceGameAnsweringBlock to display
    // current user answer made of sign and number

    // BUILD
    return (
        <div className={"bg-blueBackground h-[72px] w-[148px] min-w-[148px] flex justify-center items-center border-[2px] border-timerBlue rounded-[8px] ml-[4px]"}>
            <div className={"min-w-[32px] flex justify-center items-center"}>
                <span className={"text-white font-medium text-[40px] mb-[2px]"}>
                    {sign}
                </span>
            </div>
            <div className={"min-w-[56px] flex justify-center items-center"}>
                <span className={"text-white font-medium text-[40px]"}>
                    {answer}
                </span>
            </div>
        </div>
    );
}